export default __webpack_public_path__ + "static/media/usability-bg-mobile.d602e947.svg";